export default "__VITE_ASSET__ClGbfFjB__"